"use strict";
exports.__esModule = true;
exports.usePropertiesSearch = void 0;
var use_flex2_api_1 = require("../use-flex2-api");
var v1_routes_1 = require("./v1-routes");
var usePropertiesSearch = function () {
    var _a = (0, use_flex2_api_1.useFlex2API)({}, { manual: true }), _b = _a[0], data = _b.data, loading = _b.loading, error = _b.error, response = _b.response, execute = _a[1];
    return [
        { data: data, loading: loading, error: error, response: response },
        function (_a) {
            var searchTerm = _a.searchTerm, coordinates = _a.coordinates;
            var latQuery = (coordinates === null || coordinates === void 0 ? void 0 : coordinates.latitude) ? "lat=".concat(coordinates.latitude) : undefined;
            var longQuery = (coordinates === null || coordinates === void 0 ? void 0 : coordinates.longitude) ? "lng=".concat(coordinates.longitude) : undefined;
            var filteredQueryTerms = ["search_term=".concat(searchTerm), latQuery, longQuery].filter(function (value) { return value !== undefined; });
            var query = filteredQueryTerms.join('&');
            return execute({
                url: (0, v1_routes_1.propertySearchRoute)(query),
                method: 'GET'
            });
        },
    ];
};
exports.usePropertiesSearch = usePropertiesSearch;
